import { render, staticRenderFns } from "./ActiveContent.vue?vue&type=template&id=5f11fe2f&scoped=true"
import script from "./ActiveContent.vue?vue&type=script&lang=js"
export * from "./ActiveContent.vue?vue&type=script&lang=js"
import style0 from "./ActiveContent.vue?vue&type=style&index=0&id=5f11fe2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f11fe2f",
  null
  
)

export default component.exports